"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: credit-report/account-report.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcredit-report%2Faccount-report.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountReport = exports.ValueWithDescription = void 0;
const address_1 = require("../common/address");
const amount_1 = require("../common/amount");
const date_1 = require("../common/date");
const legal_name_1 = require("../common/legal-name");
const batch_context_1 = require("./batch-context");
const protobufPackage = 'com.step.creditreport.proto';
function createBaseValueWithDescription() {
    return { value: '', description: '' };
}
exports.ValueWithDescription = {
    fromJSON(object) {
        const message = {
            value: isSet(object.value) ? globalThis.String(object.value) : '',
            description: isSet(object.description) ? globalThis.String(object.description) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.value !== '') {
            obj.value = message.value;
        }
        if (message.description !== '') {
            obj.description = message.description;
        }
        return obj;
    },
    create(base) {
        return exports.ValueWithDescription.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseValueWithDescription();
        message.value = object.value ?? '';
        message.description = object.description ?? '';
        return message;
    },
};
function createBaseAccountReport() {
    return {
        accountStatus: exports.ValueWithDescription.fromPartial({}),
        accountType: exports.ValueWithDescription.fromPartial({}),
        accountNumber: '',
        dateOfAccountInformation: date_1.LocalDate.fromPartial({}),
        dateOfBirth: date_1.LocalDate.fromPartial({}),
        dateOfLastPayment: undefined,
        dateOpened: date_1.LocalDate.fromPartial({}),
        ecoaCode: exports.ValueWithDescription.fromPartial({}),
        address: address_1.Address.fromPartial({}),
        identificationNumber: '',
        legalName: legal_name_1.LegalName.fromPartial({}),
        paymentRating: undefined,
        portfolioType: exports.ValueWithDescription.fromPartial({}),
        telephoneNumber: '',
        termsDuration: '',
        termsFrequency: exports.ValueWithDescription.fromPartial({}),
        paymentHistory: [],
        highestCredit: undefined,
        createdMs: '0',
        context: undefined,
    };
}
exports.AccountReport = {
    fromJSON(object) {
        const message = {
            accountStatus: isSet(object.accountStatus)
                ? exports.ValueWithDescription.fromJSON(object.accountStatus)
                : exports.ValueWithDescription.fromPartial({}),
            accountType: isSet(object.accountType)
                ? exports.ValueWithDescription.fromJSON(object.accountType)
                : exports.ValueWithDescription.fromPartial({}),
            accountNumber: isSet(object.accountNumber) ? globalThis.String(object.accountNumber) : '',
            dateOfAccountInformation: isSet(object.dateOfAccountInformation)
                ? date_1.LocalDate.fromJSON(object.dateOfAccountInformation)
                : date_1.LocalDate.fromPartial({}),
            dateOfBirth: isSet(object.dateOfBirth)
                ? date_1.LocalDate.fromJSON(object.dateOfBirth)
                : date_1.LocalDate.fromPartial({}),
            dateOpened: isSet(object.dateOpened)
                ? date_1.LocalDate.fromJSON(object.dateOpened)
                : date_1.LocalDate.fromPartial({}),
            ecoaCode: isSet(object.ecoaCode)
                ? exports.ValueWithDescription.fromJSON(object.ecoaCode)
                : exports.ValueWithDescription.fromPartial({}),
            address: isSet(object.address) ? address_1.Address.fromJSON(object.address) : address_1.Address.fromPartial({}),
            identificationNumber: isSet(object.identificationNumber)
                ? globalThis.String(object.identificationNumber)
                : '',
            legalName: isSet(object.legalName)
                ? legal_name_1.LegalName.fromJSON(object.legalName)
                : legal_name_1.LegalName.fromPartial({}),
            portfolioType: isSet(object.portfolioType)
                ? exports.ValueWithDescription.fromJSON(object.portfolioType)
                : exports.ValueWithDescription.fromPartial({}),
            termsDuration: isSet(object.termsDuration) ? globalThis.String(object.termsDuration) : '',
            termsFrequency: isSet(object.termsFrequency)
                ? exports.ValueWithDescription.fromJSON(object.termsFrequency)
                : exports.ValueWithDescription.fromPartial({}),
            paymentHistory: globalThis.Array.isArray(object?.paymentHistory)
                ? object.paymentHistory.map((e) => exports.ValueWithDescription.fromJSON(e))
                : [],
            createdMs: isSet(object.createdMs) ? globalThis.String(object.createdMs) : '0',
        };
        if (isSet(object.dateOfLastPayment)) {
            message.dateOfLastPayment = date_1.LocalDate.fromJSON(object.dateOfLastPayment);
        }
        if (isSet(object.paymentRating)) {
            message.paymentRating = exports.ValueWithDescription.fromJSON(object.paymentRating);
        }
        if (isSet(object.telephoneNumber)) {
            message.telephoneNumber = globalThis.String(object.telephoneNumber);
        }
        if (isSet(object.highestCredit)) {
            message.highestCredit = amount_1.Amount.fromJSON(object.highestCredit);
        }
        if (isSet(object.context)) {
            message.context = batch_context_1.BatchContext.fromJSON(object.context);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountStatus !== undefined) {
            obj.accountStatus = exports.ValueWithDescription.toJSON(message.accountStatus);
        }
        if (message.accountType !== undefined) {
            obj.accountType = exports.ValueWithDescription.toJSON(message.accountType);
        }
        if (message.accountNumber !== '') {
            obj.accountNumber = message.accountNumber;
        }
        if (message.dateOfAccountInformation !== undefined) {
            obj.dateOfAccountInformation = date_1.LocalDate.toJSON(message.dateOfAccountInformation);
        }
        if (message.dateOfBirth !== undefined) {
            obj.dateOfBirth = date_1.LocalDate.toJSON(message.dateOfBirth);
        }
        if (message.dateOfLastPayment !== undefined) {
            obj.dateOfLastPayment = date_1.LocalDate.toJSON(message.dateOfLastPayment);
        }
        if (message.dateOpened !== undefined) {
            obj.dateOpened = date_1.LocalDate.toJSON(message.dateOpened);
        }
        if (message.ecoaCode !== undefined) {
            obj.ecoaCode = exports.ValueWithDescription.toJSON(message.ecoaCode);
        }
        if (message.address !== undefined) {
            obj.address = address_1.Address.toJSON(message.address);
        }
        if (message.identificationNumber !== '') {
            obj.identificationNumber = message.identificationNumber;
        }
        if (message.legalName !== undefined) {
            obj.legalName = legal_name_1.LegalName.toJSON(message.legalName);
        }
        if (message.paymentRating !== undefined) {
            obj.paymentRating = exports.ValueWithDescription.toJSON(message.paymentRating);
        }
        if (message.portfolioType !== undefined) {
            obj.portfolioType = exports.ValueWithDescription.toJSON(message.portfolioType);
        }
        if (message.telephoneNumber !== undefined && message.telephoneNumber !== '') {
            obj.telephoneNumber = message.telephoneNumber;
        }
        if (message.termsDuration !== '') {
            obj.termsDuration = message.termsDuration;
        }
        if (message.termsFrequency !== undefined) {
            obj.termsFrequency = exports.ValueWithDescription.toJSON(message.termsFrequency);
        }
        if (message.paymentHistory?.length) {
            obj.paymentHistory = message.paymentHistory.map((e) => exports.ValueWithDescription.toJSON(e));
        }
        if (message.highestCredit !== undefined) {
            obj.highestCredit = amount_1.Amount.toJSON(message.highestCredit);
        }
        if (message.createdMs !== '0') {
            obj.createdMs = message.createdMs;
        }
        if (message.context !== undefined) {
            obj.context = batch_context_1.BatchContext.toJSON(message.context);
        }
        return obj;
    },
    create(base) {
        return exports.AccountReport.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccountReport();
        message.accountStatus = (object.accountStatus !== undefined && object.accountStatus !== null)
            ? exports.ValueWithDescription.fromPartial(object.accountStatus)
            : exports.ValueWithDescription.fromPartial({});
        message.accountType = (object.accountType !== undefined && object.accountType !== null)
            ? exports.ValueWithDescription.fromPartial(object.accountType)
            : exports.ValueWithDescription.fromPartial({});
        message.accountNumber = object.accountNumber ?? '';
        message.dateOfAccountInformation =
            (object.dateOfAccountInformation !== undefined && object.dateOfAccountInformation !== null)
                ? date_1.LocalDate.fromPartial(object.dateOfAccountInformation)
                : date_1.LocalDate.fromPartial({});
        message.dateOfBirth = (object.dateOfBirth !== undefined && object.dateOfBirth !== null)
            ? date_1.LocalDate.fromPartial(object.dateOfBirth)
            : date_1.LocalDate.fromPartial({});
        message.dateOfLastPayment =
            (object.dateOfLastPayment !== undefined && object.dateOfLastPayment !== null)
                ? date_1.LocalDate.fromPartial(object.dateOfLastPayment)
                : undefined;
        message.dateOpened = (object.dateOpened !== undefined && object.dateOpened !== null)
            ? date_1.LocalDate.fromPartial(object.dateOpened)
            : date_1.LocalDate.fromPartial({});
        message.ecoaCode = (object.ecoaCode !== undefined && object.ecoaCode !== null)
            ? exports.ValueWithDescription.fromPartial(object.ecoaCode)
            : exports.ValueWithDescription.fromPartial({});
        message.address = (object.address !== undefined && object.address !== null)
            ? address_1.Address.fromPartial(object.address)
            : address_1.Address.fromPartial({});
        message.identificationNumber = object.identificationNumber ?? '';
        message.legalName = (object.legalName !== undefined && object.legalName !== null)
            ? legal_name_1.LegalName.fromPartial(object.legalName)
            : legal_name_1.LegalName.fromPartial({});
        message.paymentRating = (object.paymentRating !== undefined && object.paymentRating !== null)
            ? exports.ValueWithDescription.fromPartial(object.paymentRating)
            : undefined;
        message.portfolioType = (object.portfolioType !== undefined && object.portfolioType !== null)
            ? exports.ValueWithDescription.fromPartial(object.portfolioType)
            : exports.ValueWithDescription.fromPartial({});
        message.telephoneNumber = object.telephoneNumber ?? '';
        message.termsDuration = object.termsDuration ?? '';
        message.termsFrequency = (object.termsFrequency !== undefined && object.termsFrequency !== null)
            ? exports.ValueWithDescription.fromPartial(object.termsFrequency)
            : exports.ValueWithDescription.fromPartial({});
        message.paymentHistory =
            object.paymentHistory?.map((e) => exports.ValueWithDescription.fromPartial(e)) || [];
        message.highestCredit = (object.highestCredit !== undefined && object.highestCredit !== null)
            ? amount_1.Amount.fromPartial(object.highestCredit)
            : undefined;
        message.createdMs = object.createdMs ?? '0';
        message.context = (object.context !== undefined && object.context !== null)
            ? batch_context_1.BatchContext.fromPartial(object.context)
            : undefined;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=account-report.js.map